module.exports = __webpack_public_path__ + "static/media/process.bd84171a.png";